<template>
  <div>
    <!-- <yjheader leftIcon=true rightIcon=true title="交易"></yjheader> -->
    <!-- <yjheader title="交易"></yjheader> -->
    <div class="headerWrapper">
      交易
      <i class="icon iconfont install" @click="goSet">&#xe66e;</i>
    </div>
    <div class="wrapper">
      <div class="account-wrapper">
        <p class="accout-title">{{pageData.account.title}}</p>
        <p class="accout-num">{{pageData.account.value}}<span v-if="userName">({{userName}})</span></p>
      </div>

      <div class="capital-wrapper">
        <div class="capital-w-left">
          <span class="span-title">{{pageData.rights.title}}</span><br/>
          <span class="span-value">{{pageData.rights.value}}</span><br/>
          <span class="span-title">{{pageData.usable.title}}</span><br/>
          <span>{{pageData.usable.value}}</span><br/>
        </div>
        <div class="capital-w-rigth">
          <span class="span-title">{{pageData.profitAloss.title}}</span><br/>
          <span :class="{gain:pageData.profitAloss.value>=0,lose:pageData.profitAloss.value<0}"
            class="span-value">{{pageData.profitAloss.value}}</span><br/>
          <span class="span-title">{{pageData.desirable.title}}</span><br/>
          <span>{{pageData.desirable.value}}</span><br/>
        </div>
      </div>

      <div class="menu">
        <ul>
          <li v-for="(item,index) in menuData"
            :key="index"
            :class="{liActive:isActive==index}"
            v-tap
            @tap="link(index)">
            <i class="icon iconfont"
              v-html="item.tobarIcon"></i><br>
            <span>{{item.tobarContent}}</span>

          </li>
        </ul>
      </div>

      <div class="btn_div_d"
        v-tap
        @tap="go_login">
        <div class="btn">
          退出
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import yjheader from "@/components/common/yjheader";
import art from "../../../static/js/proto/art/Art.js";
import model from "../../../static/js/proto/Model.js";
import front from "../../../static/js/proto/CtpFront.js";
import * as SubUtils from "@/store/SubUtils";
export default {
  name: "trade",
  components: {
    yjheader
  },
  data() {
    return {
      userName: '',
      pageData: {
        account: { title: "账号", value: localStorage.accountNum },
        rights: {
          title: "权益",
          value: "0.00"
        },
        usable: {
          title: "可用",
          value: "0.00"
        },
        profitAloss: {
          title: "盈亏",
          value: "-0.00"
        },
        desirable: {
          title: "可取",
          value: "0.00"
        }
      },
      menuData: [
        {
          tobarLink: "/home/order",
          tobarIcon: "&#xe624;",
          tobarContent: "下单"
        },
        {
          tobarLink: "/home/store",
          tobarIcon: "&#xe7b9;",
          tobarContent: "持仓"
        },
        {
          tobarLink: "/home/cancel",
          tobarIcon: "&#xe609;",
          tobarContent: "撤单"
        },
        {
          tobarLink: "/home/capital",
          tobarIcon: "&#xe60a;",
          tobarContent: "资金"
        },
        {
          tobarLink: "/home/query",
          tobarIcon: "&#xe603;",
          tobarContent: "查询"
        }
      ],
      isActive: 12
    };
  },
  mounted() {},
  beforeDestroy() {},

  activated() {
    this.userName = localStorage.userName;
    front.autoMount(art.bind(this, this.load));
    this.$store.commit("selectIndex", 2);
  },
  deactivated() {
    model.trader.queryCapital.stop();
  },

  methods: {
    load(onFail) {
      model.capital.attach("trade", art.bind(this, this.onUpdateCapital));
      model.trader.queryCapital.start();
      // 自动重连后切回交易页面
      if (onFail instanceof Function) {
        this.$router.push({ path: "/home/trade" });
      }
    },
    onUpdateCapital(capital) {
      if (capital === undefined) {
        this.pageData.rights.value = 0.0;
        this.pageData.usable.value =  0.0;
        this.pageData.profitAloss.value = 0.0;
        this.pageData.desirable.value = 0.0;
        this.pageData.account.value = 0.0;
        return;
      }
      this.pageData.rights.value = capital["balance"].toFixed(2);
      this.pageData.usable.value = capital["available"].toFixed(2);
      this.pageData.profitAloss.value = (Number(capital["positionProfit"]) + Number(capital["closeProfit"])).toFixed(2);
      this.pageData.desirable.value = capital["withdrawQuota"].toFixed(2);
      this.pageData.account.value = capital["account"];
    },
    go_login() {
      front.close();
      SubUtils.clearAll();
      footerIndex = 0;
      this.$router.push({ path: "/" });
      this.$store.commit("selectLoad"); // 清空自选合约
    },
    link(index) {
      this.isActive = index;
      this.$router.push({ path: "/tradeDetail/" + index });
    },
    goSet() {
      this.$router.push('/setPage');
    }
  },
};
</script>

<style scoped>
.iconfont {
  font-family: "iconfont" !important;
  font-size: 0.36rem;
  font-style: normal;
  /*font-weight: bold;*/
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
  /*color: #fff;*/
  /*color:#26a2ff;*/
  color: #a57518;
}

.headerWrapper {
  background: #1c201f;
  color: #fff;
  font-size: 0.36rem;
  vertical-align: center;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  position: relative;
}
.headerWrapper .install {
  position: absolute;
  top: 0;
  right: 0.3rem;
  color: #fff;
}
.account-wrapper {
  height: 1.2rem;
  font-size: 0.32rem;
  /*border-bottom: 1px solid #dddcdd;*/

  display: flex;
  justify-content: center;
  flex-direction: column;

  padding-left: 0.3rem;
  background: #1f1f1f;
}

.accout-title {
  font-weight: bold;
  font-size: 0.34rem;
  height: 0.55rem;
}

.capital-wrapper {
  /*border-top: 1px solid #dddcdd;*/
  /*border-bottom: 1px solid #dddcdd;*/
  font-size: 0.28rem;
  padding: 0.3rem;
  margin-top: 0.25rem;
  background: #1f1f1f;
  display: flex;
  justify-content: space-around;
}

.capital-w-left {
  /*border-right: 1px solid #dddcdd;*/
  width: 48%;
  position: relative;
}

.capital-w-left::after {
  content: "  ";
  position: absolute;
  left: 98.5%;
  top: 0;
  width: 1px;
  height: 100%;
  background-color: #fff;
  /*background-color: red;*/
  /*background-color: #202228;*/
  /* 如果不用 background-color, 使用 border-top:1px solid #e0e0e0; */
  -webkit-transform: scaleX(0.5);
  transform: scaleX(0.5);
}

.capital-w-rigth {
  padding-left: 5%;
  width: 45%;
}

.span-title {
  font-size: 0.32rem;
  display: inline-block;
  margin-bottom: 3px;
  font-weight: bold;
}

.span-value {
  display: inline-block;
  margin-bottom: 0.15rem;
}

.menu {
  height: 1.3rem;
  background: #1f1f1f;
  /*border-top: 1px solid #dddcdd;*/
  /*border-bottom: 1px solid #dddcdd;*/
  margin-top: 0.25rem;
  display: flex;
  justify-content: center;
  flex-direction: column;
  color: #fff;
  /*color:#26a2ff;*/
}

.menu ul {
  font-size: 0;
  text-align: center;
}

.menu ul li {
  display: inline-block;
  /*font-size: 0.24rem;*/
  /* height: 100%; */
  /*line-height: 0.3rem;*/
  /*color: #7d7d7d;*/
  /*width: 1.5rem;*/
  width: 20%;
  /*text-align: center;*/
  /*padding-top: 0.18rem;*/
}

.menu ul li span {
  font-size: 0.3rem;
  display: inline-block;
  margin-top: 0.05rem;
}

.btn_div_d {
  /*margin-top: 0.4rem;*/
  /*background: #fff;*/
  color: #fff;
  border: none;
  width: 90%;
  line-height: 0.8rem;
  font-size: 0.32rem;
  border-radius: 0 0 5px 5px;
  margin: 0.4rem auto;
}

.btn_div_d .btn {
  text-align: center;
  line-height: 0.8rem;
  width: 100%;
  height: 0.8rem;
  margin: 0 auto;
  border: 0;
  border-radius: 0.08rem;
  display: block;
  font-size: 0.32rem;

  /*background: #1F1F1F;*/
  background: #ee3f44;
}

.liActive {
  /*background: #3583ff;*/
  background: rgba(255, 211, 146, 0.25);
  padding: 0.24rem 0;
}

.gain {
  color: red;
}

.lose {
  color: #1ac31a;
}
</style>




// WEBPACK FOOTER //
// src/components/yj/trade.vue